import { NetworkSetup } from "../network-setup";
import { SKRT_ABI } from "./skrt-abi";
import { USDT_ABI } from "./usdt-abi";

const SKRT_ADDRESS = "0x887168120cb89Fb06F3E74Dc4AF20D67dF0977f6";
const USDT_ADDRESS = "0xdac17f958d2ee523a2206206994597c13d831ec7";

export const ethNetworkSetup: NetworkSetup = {
  chain: "ETH",
  contracts: {
    skrt: {
      address: SKRT_ADDRESS,
      abi: SKRT_ABI,
      decimals: 18, 
    },
    usdt: {
      decimals: 6,
      address: USDT_ADDRESS,
      abi: USDT_ABI,
    },
  },

  purchase: () =>
    Promise.reject("purchasing is not supported for this network"),
  stake: () => Promise.reject("staking is not supported for this network"),
  unstake: () => Promise.reject("unstaking is not supported for this network"),
};
